var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSadFace = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 163,
  height: 141,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#sad-face_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#sad-face_svg__b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 130,
  height: 109,
  x: 16.5,
  y: 8,
  fill: "#fff",
  rx: 30
}), /*#__PURE__*/React.createElement("mask", {
  id: "sad-face_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5 8h130v28h-130z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F1F5F9",
  d: "M16.5 8h130v28h-130z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2E8F0",
  d: "M146.5 35h-130v2h130z",
  mask: "url(#sad-face_svg__c)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 59.5,
  r: 5,
  fill: "#CBD5E1",
  stroke: "#CBD5E1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 59.5,
  r: 5,
  fill: "#CBD5E1",
  stroke: "#CBD5E1"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#CBD5E1",
  strokeWidth: 3,
  d: "m55.5 93 6.39-3.417a40 40 0 0 1 37.72 0L106 93"
})), /*#__PURE__*/React.createElement("rect", {
  width: 129,
  height: 108,
  x: 17,
  y: 8.5,
  stroke: "#E2E8F0",
  rx: 29.5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "sad-face_svg__b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 130,
  height: 109,
  x: 16.5,
  y: 8,
  fill: "#fff",
  rx: 30
})), /*#__PURE__*/React.createElement("filter", {
  id: "sad-face_svg__a",
  width: 162,
  height: 141,
  x: 0.5,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0413508 0 0 0 0 0.0395417 0 0 0 0 0.13 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1248_10530"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1248_10530",
  result: "shape"
})))));
export { SvgSadFace as ReactComponent };
export default __webpack_public_path__ + "255f3315a376162d1dcf3890c72a1858.svg";